<template>
  <div class="row">
    <v-col md="12">
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
    <v-col>
      <v-sheet color="white" elevation="1" class="pa-5"
        ><h2 class="text-warning">Learner Not Selected</h2>
        <p class="sub-title">
          Please select learner from
          <em><strong>View/Edit Learners</strong></em>
          <!--router-link :to="{ name: 'ManageLearners' }"
            >View/Edit Learners
          </router-link-->
        </p></v-sheet
      ></v-col
    >
  </div>
</template>

<script>
export default {
  name: "MissingLearnerID",
  data() {
    return {
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/dashboard/home",
        },
        {
          text: "View/Edit Learner",
          disabled: false,
          href: "/dashboard/managelearners",
        },
        {
          text: "Edit Learner",
          disabled: true,
          href: "/dashboard/editlearner",
        },
      ],
    };
  },
};
</script>

<style></style>
